import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_REGISTRATION = Symbol('registration');

export const REGISTRATION_ROUTE_NAME = Symbol('registration');
export const REGISTRATION_CONFIRMATION_ROUTE_NAME = Symbol('registration.confirmation');
export const REGISTRATION_DONE_ROUTE_NAME = Symbol('registration.done');
export const REGISTRATION_AFFILIATE_ROUTE_NAME = Symbol('registration.affiliate');

export const REGISTER_URL = 'anonym/registrations';
export const REGISTER_MUTATION_KEY = 'register';

export const REGISTER_CONFIRMATION_URL = 'confirmation';
export const REGISTER_CONFIRMATION_MUTATION_KEY = 'register.confirmation';

export const REGISTER_AFFILIATE_REFERRAL_URL = 'anonym/registrations/referrals_token';
export const REGISTER_AFFILIATE_REFERRAL_MUTATION_KEY = 'register.affiliate-referral';

export const REGISTRATION_PERMISSIONS = {
  REGISTER: new Permission(undefined, undefined, PermissionsList.anonymous.REGISTER),
};
